<template>
  <div>
    <b-row>
      <b-col>
        <b-card header="Rol">
          <b-row>
            <b-col>
              <b-form-group>
                <label for="tfrol">Nombre</label>
                <b-form-input
                  type="text"
                  id="tfrol"
                  placeholder="Ej.: administrador"
                  v-model="role.name"
                  @blur="$v.role.name.$touch"
                  :state="$v.role.name.$dirty ? !$v.role.name.$error : null"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="tfnombre">Descripción</label>
                <b-form-input
                  type="text"
                  id="tfnombre"
                  placeholder="Ej.: acceso a todas las funciones"
                  v-model="role.description"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card header="Permisos">
          <b-table
            bordered
            :items="permissions"
            :fields="permissionsTable.fields"
            responsive="sm"
            :perPage="permissionsTable.perPage"
            :currentPage="permissionsTable.currentPage"
            :busy="!permissions.length && !permissionsTable.empty"
            :show-empty="permissionsTable.empty"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>

            <template slot="empty" slot-scope="scope">
              <h4 class="text-center">No se encontraron resultados</h4>
            </template>

            <template slot="selected" slot-scope="scope">
              <div class="text-center">
                <b-checkbox v-model="scope.item.selected" class="align-middle" />
              </div>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <nav>
                <b-pagination
                  size="sm"
                  :total-rows="permissions.length"
                  :per-page="permissionsTable.perPage"
                  v-model="permissionsTable.currentPage"
                  prev-text="Anterior"
                  next-text="Siguiente"
                  hide-goto-end-buttons
                />
              </nav>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="row buttons-nav-container">
          <b-col align="right">
            <b-button variant="secondary" to="/roles">
              <i class="fa fa-arrow-left" />
              Volver
            </b-button>
            <b-button variant="danger" v-b-modal.delete v-if="roleId">
              <i class="fa fa-trash" />
              Eliminar
            </b-button>
            <b-button variant="success" @click="saveRole">
              <i class="fa fa-save" />
              Guardar
            </b-button>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal id="delete" title="Eliminar Rol" @ok="deleteRole()">
      <p class="my-4">¿Desea eliminar el rol seleccionado?</p>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  props: {
    roleId: {
      default: null
    }
  },
  data() {
    return {
      permissions: [],
      permissionsSelected: [],
      role: {},
      permissionsTable: {
        empty: false,
        currentPage: 1,
        perPage: 5,
        fields: [
          {
            label: 'Nombre',
            key: 'name'
          },
          {
            label: 'Habilitado',
            key: 'selected'
          }
        ]
      }
    };
  },

  validations: {
    role: {
      name: { required, minLength: minLength(3) }
    }
  },

  methods: {
    getPermissions() {
      return this.$api('/roles/permissions').then(res => {
        this.permissions = res.data;
        if (!res.data.length) this.permissionsTable.empty = true;
      });
    },

    openRole(id) {
      return this.$api(`/roles/open/${id}`).then(res => {
        this.role = res.data.role;
        this.permissions.forEach(per => {
          if (res.data.permissions.find(p => p.id === per.id)) {
            per.selected = true;
          }
        });
      });
    },

    selectPermission(items) {
      this.permissionsSelected = items;
    },

    saveRole() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error('Complete los campos requeridos.', 'Error');
        return null;
      }

      const role = this.role;
      const permissions = this.permissions.filter(per => per.selected);

      if (!this.roleId) {
        // se crea un nuevo rol
        this.$api
          .post('/roles/create', {
            role: role,
            permissions: permissions
          })
          .then(res => {
            if (!res.data.error) {
              this.$toast.success(res.data.message, '¡Listo!');
              this.$router.push('/auth/roles')
            } else {
              this.$toast.error(res.data.message, 'Error');
            }
          })
          .catch(e => {
           this.$toast.error('No se pudo guardar el Rol, verifique que no exista ya.', 'Error');
          });
      } else {
        // se actualiza un rol seleccionado
        this.$api
          .post('/roles/update', {
            role: role,
            permissions: permissions
          })
          .then(res => {
            if (!res.data.error) {
              this.$toast.success(res.data.message, '¡Listo!')
              this.$router.push('/auth/roles')
            } else {
              this.$toast.error(res.data.message, 'Error');
            }
          });
      }
    },

    deleteRole() {
      this.$api
        .post('/roles/delete', {
          id: this.roleId
        })
        .then(res => {
          if (res.data.error) {
            this.$toast.error(res.data.message, 'Error');
          } else {
            this.$toast.success(res.data.message, '¡Listo!')
            this.$router.push('/auth/roles')
          }
        });
    }
  },
  created: async function() {
    await this.getPermissions();

    const id = this.$route.params.id
    if (id) {
      this.roleId = id
      this.openRole(this.roleId);
    }
  }
};
</script>
